export default {
  title: "Unsubmitted Work",
  text_body:
    "You have <b class='text-info'>Unsubmitted Work</b> for this <b class='text-info'>{entity}</b>!",
  untitled_work: "Untitled Work",
}
